// import pageContainer from '@/views/components/pageContainer';
import { Image } from 'vant';
import { Toast } from 'vant';
function plugins(Vue) {
  // Vue.component('page-container', pageContainer);
  Vue.component('zan-img', Image);
}
export default plugins;
